<script setup lang="ts">

import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppTable, AppTd, AppTh, AppTr } from '@shared/ui/tables'
import { AppIcon } from '@shared/ui/icons'
import { CardAdmin } from '@shared/ui/cards'

import OrderPaymentActions from './OrderPaymentActions.vue'
import { useOrderPaymentLog } from '../model/order-payment-log.hook'

defineOptions({
  name: 'SectionOrderPaymentLog',
})

const COLUMNS = ['ID', 'Payment provider', 'External id', 'Status', 'Type', 'Created at']

const {
  refPayments,
  hasPayments,
  refIsOpen,
  toggle,
  getType,
  formatDate,
  openChangelog,
} = useOrderPaymentLog()
</script>

<template>
  <CardAdmin
    v-if="hasPayments"
    fullwidth
    class="section-order-payment-log"
  >
    <template #title>
      <button
        type="button"
        class="section-order-payment-log__toggle"
        :aria-expanded="refIsOpen"
        @click="toggle"
      >
        <AppText name="h3">
          Payment log
        </AppText>
      </button>
    </template>
    <template #header>
      <button
        type="button"
        :class="['section-order-payment-log__chevron', { 'section-order-payment-log__chevron--open': refIsOpen }]"
        :aria-expanded="refIsOpen"
        title="Toggle payment log"
        @click="toggle"
      >
        <AppIcon
          :icon="faChevronDown"
          size="small"
        />
      </button>
    </template>

    <div
      v-if="refIsOpen"
      class="section-order-payment-log__log"
    >
      <AppTable
        class="rounded-table"
        :paginated="false"
      >
        <template #head>
          <AppTr>
            <AppTh
              v-for="column in COLUMNS"
              :key="column"
              class="xy-16"
            >
              <AppText
                name="body1-medium"
                color="slate-900"
              >
                {{ column }}
              </AppText>
            </AppTh>
            <AppTh class="xy-16 section-order-payment-log__actions-cell" />
          </AppTr>
        </template>
        <template #body>
          <AppTr
            v-for="payment in refPayments"
            :key="payment.id"
          >
            <AppTd class="xy-16">
              <AppText name="body1">
                {{ payment.id }}
              </AppText>
            </AppTd>
            <AppTd class="xy-16">
              <AppText name="body1">
                {{ payment.method }}
              </AppText>
            </AppTd>
            <AppTd class="xy-16">
              <AppText name="body1">
                {{ payment.external_id }}
              </AppText>
            </AppTd>
            <AppTd class="xy-16">
              <AppText name="body1">
                {{ payment.status }}
              </AppText>
            </AppTd>
            <AppTd class="xy-16">
              <AppText name="body1">
                {{ getType(payment) }}
              </AppText>
            </AppTd>
            <AppTd class="xy-16">
              <AppText name="body1">
                {{ formatDate(payment.created_at) }}
              </AppText>
            </AppTd>
            <AppTd class="zero-padding section-order-payment-log__actions-cell">
              <OrderPaymentActions
                :payment-id="payment.id"
                @click:changelog="openChangelog(payment)"
              />
            </AppTd>
          </AppTr>
        </template>
      </AppTable>
    </div>
    <!-- Keeps the body non-empty while folded, so the card shows no "No info" placeholder. -->
    <div v-else />
  </CardAdmin>
</template>

<style scoped lang="scss" src="./SectionOrderPaymentLog.scss" />
